import api from '@/api'
import router, { constantRoutes } from '@/router'

// 开发环境不使用懒加载
const _import = require('../../router/import-' + process.env.NODE_ENV)

const state = {
  userInfo: null, // 用户信息
  userType: '', // 用户类型
  menuList: [], // 菜单路由
  addRouteList: [], // 动态路由
  businessCode: '', // 登录业务方code
  serviceExtension: {
	endDay: '', //服务结束时间
	status: '', //是否已经申请延期
	applyExpirationTime: '' // 服务延期至日期
  }, // 服务延期状态
}

const mutations = {
  // 设置用户信息
  setUserInfo(state, data) {
    state.userInfo = data
    this.commit('openWebsocket', data.userId)
  },
  // 设置用户类型
  setUserType(state, data) {
    state.userType = data
  },
  // 设置服务结束时间
  setServiceExtension(state, data) {
    state.serviceExtension = data
  },
  // 设置菜单路由信息
  setMenuList(state, data) {
    state.menuList = formatMenuList(data)
    this.commit('user/setRouteList', data) // 递归获取动态路由
    const list = constantRoutes
    list[0].children = list[0].children.concat(state.addRouteList)
    list.push({
      path: '*',
      name: '404',
      component: _import('/404')
    })
    router.addRoutes(list)
  },

  setRouteList(state, data = []) {
    data.forEach(item => {
      // 获取为路由的item
      if (item.type === 'router') {
        const routerItem = {
          path: item.path,
          name: item.name,
          component: _import(item.href),
          meta: item.meta
        }
        state.addRouteList.push(routerItem)
      }

      // 存在下级则递归
      if (item.children && item.children.length > 0) {
        this.commit('user/setRouteList', item.children)
      }
    })
  },
  // 获取登录code
  setBusinessCode(state, data) {
    state.businessCode = data
  }
}

const actions = {
  // 获取用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      api.user
        .getUserInfo()
        .then(({ data }) => {
          if (data.code == 200) {
            const USER_INFO = data.data
            window.sessionStorage.setItem('userInfo', JSON.stringify(USER_INFO))
            commit('setUserInfo', USER_INFO)
            resolve(USER_INFO)
          } else {
            reject(data)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 获取菜单路由信息
  getMenu({ commit }) {
    return new Promise((resolve, reject) => {
      api.user
        .getMenuList()
        .then(({ data }) => {
          if (data.code == 200) {
            const MENU_LIST = data.data.permsList
            // 存vuex并动态加载到路由
            commit('setMenuList', JSON.parse(MENU_LIST))
            // 存储用户类型
            commit('setUserType', data.data.userType)
            resolve(MENU_LIST)
          } else {
            reject(data)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 清除信息
  resetAuth() {
    return new Promise((resolve, reject) => {
      try {
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('userInfo')
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }
}

function formatMenuList(data) {
  const menu = JSON.parse(JSON.stringify(data))

  menu.forEach((item, index) => {
    if (item.meta && item.meta.isMenu != '1') {
      menu.splice(index, 1)
    }

    if (item.children && item.children.length > 0) {
      getMenuChildren(item.children)
    }
  })
  return menu
}

function getMenuChildren(data) {
  data.forEach((item, index) => {
    if (item.meta && item.meta.isMenu != '1') {
      data.splice(index, 1)
    }

    if (item.children && item.children.length > 0) {
      getMenuChildren(item.children)
    }
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
